import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CollateralNotes } from "@app/models/collateral-notes";
import { CollateralNotesService } from "@app/services/collateral-notes.service";

@Component({
    selector: "app-select-collateral-note-popup",
    templateUrl: "./select-collateral-note-popup.component.html",
    styleUrls: ["./select-collateral-note-popup.component.css"],
    standalone: false
})
export class SelectCollateralNotePopupComponent implements OnInit {
  @Input() collateralNotes: Array<CollateralNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedCollateralNotes: Array<CollateralNotes>;
  @Output() onSubmit = new EventEmitter<Array<CollateralNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private collateralNotesService: CollateralNotesService) {}

  ngOnInit() {
    if (!this.selectedCollateralNotes) {
      this.selectedCollateralNotes = [];
    }
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(collateralNote) {
    if (collateralNote) {
      const parentIds = this.collateralNotesService.findCollateralNoteParents(collateralNote, this.collateralNotes);
      this.selectedCollateralNotes = [
        ...this.selectedCollateralNotes.filter((p) => !this.checkIfParentIdInTheList(parentIds, p)),
      ];
      this.selectedCollateralNotes.push(collateralNote);
    }
  }

  onSave() {
    this.onSubmit.emit(this.selectedCollateralNotes);
  }

  deleteSelectedCollateralNote(collateralNote) {
    if (collateralNote) {
      var children = this.findAllChidren(collateralNote);
      this.selectedCollateralNotes = this.selectedCollateralNotes.filter((item) => !children.find((p) => p.id == item.id));

      if (collateralNote.parentId) {
        var parent = this.collateralNotesService.findCollateralNoteById(collateralNote.parentId, this.collateralNotes);
        this.selectedCollateralNotes.push(parent);
      }
    }
  }

  checkIfParentIdInTheList(checkArray: CollateralNotes[], collateralNote: CollateralNotes) {
    const set1 = new Set(checkArray);
    const parents = this.collateralNotesService.findCollateralNoteParents(collateralNote, this.collateralNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChidren(collateralNote: CollateralNotes) {
    var items = [];
    if (collateralNote) {
      items.push(collateralNote);
      if (collateralNote.subCollateralNotes && collateralNote.subCollateralNotes.length > 0) {
        collateralNote.subCollateralNotes.forEach((p) => {
          items = items.concat(this.findAllChidren(p));
        });
      }
    }
    return items;
  }
}
